import TranslatedText from "../i18n";

export default function News() {
  return (
    <div id="news">
      <div className="container">

        <div className="row">
          <div className="col-md-12">
            <br /><br />
            <div className="section-heading">
              <br /><br />
              <hr style={{ height: "15px" }} />
              <TranslatedText textKey="news_title" />
              <hr style={{ height: "5px" }} />
              <br /><br />
            </div>
          </div>
        </div>

        <div className="row">

          <div className="col-md-6">
            <h4 style={{ fontSize: 18 }}><a target="_blank" rel="noreferrer" href="https://sevilla.abc.es/andalucia/sevi-andalucia-lidera-estudios-secuenciacion-genomica-covid-espana-202110282002_noticia.html">Andalucía lidera los estudios de secuenciación genómica del Covid en España</a></h4>
            <br />
            <a target="_blank" rel="noreferrer" href="https://sevilla.abc.es/andalucia/sevi-andalucia-lidera-estudios-secuenciacion-genomica-covid-espana-202110282002_noticia.html"> <img className="img-responsive" src="https://static3-sevilla.abc.es/media/andalucia/2021/10/28/s/1436489108-U18816417470sGk-620x349@abc.JPG" alt="sevilla abc" /></a>
            <br /><br />

            <h5 style={{ fontSize: 16 }}><i>Ha secuenciado el 59 por ciento de las muestras totales para determinar prevalencia, mutaciones y variantes del coronavirus</i></h5>
            <br />
            <p className="text-justify">Andalucía se sitúa a la cabeza de la secuenciación genómica del coronavirus a nivel nacional. Según ha informado este jueves la Junta de Andalucía en un comunicado, durante la pandemia se han secuenciado 13.880 muestras de coronavirus, lo que supone el 59,3% de lo que se ha secuenciado en todo el país, según datos del proyecto 'SeqCovid'.</p>
            <br />
            <p className="text-justify"> <a href="https://sevilla.abc.es/andalucia/sevi-andalucia-lidera-estudios-secuenciacion-genomica-covid-espana-202110282002_noticia.html"><i>leer más en su fuente original...</i></a></p>
          </div>

          <div className="col-md-6">
            <h4 style={{ fontSize: 18 }}><a target="_blank" rel="noreferrer" href="https://www.diariocordoba.com/andalucia/2022/03/21/total-170-investigaciones-21-600-64110984.html">Un total de 170 investigaciones y más de 21.600 genomas secuenciados tras dos años de pandemia</a></h4>
            <br />
            <a target="_blank" rel="noreferrer" href="https://www.diariocordoba.com/andalucia/2022/03/21/total-170-investigaciones-21-600-64110984.html"> <img className="img-responsive" src="https://estaticos-cdn.prensaiberica.es/clip/eb5a8bc6-c3f3-4ba6-a417-008841e18945_16-9-discover-aspect-ratio_default_0.jpg" alt="prensaiberica" /></a>
            <br /><br />

            <h5 style={{ fontSize: 16 }}><i>La Consejería de Salud de la Junta de Andalucía ha captado más de 11,2 millones de euros en proyectos y estudios clínicos desarrollados en las ocho provincias</i></h5>
            <br />
            <p className="text-justify">Cuando ya se han cumplido dos años desde que la OMS declarase la situación de pandemia por el nuevo coronavirus, la Consejería de Salud y Familias hace balance de la investigación que se han realizado en este periodo de tiempo y que ha centrado los esfuerzos de una gran mayor parte de la comunidad investigadora. </p>
            <br />
            <p className="text-justify"> <a href="https://www.diariocordoba.com/andalucia/2022/03/21/total-170-investigaciones-21-600-64110984.html"><i>leer más en su fuente original...</i></a></p>
          </div>


        </div>

        <br /><br /><br />
        <hr style={{ height: "5px" }} />
        <br /><br /><br /><br />


        <div className="row">
          <div className="col-md-6">
            <h4 style={{ fontSize: 18 }}><a target="_blank" rel="noreferrer" href="https://www.diariosur.es/sociedad/salud/papel-crucial-vitamina-d-supervivencia-frente-covid-20220411135009-nt.html">El papel crucial de la vitamina D en la supervivencia frente al Covid </a></h4>
            <br />
            <a target="_blank" rel="noreferrer" href="https://www.diariosur.es/sociedad/salud/papel-crucial-vitamina-d-supervivencia-frente-covid-20220411135009-nt.html"> <img className="img-responsive" src="https://static.diariosur.es/www/multimedia/202204/11/media/cortadas/dopazo-Ru1qT68Zyq42PFIoM0N2ZbJ-624x385@Diario%20Sur.jpg" alt="vanguardia logo" /></a>
            <br /><br />

            <h5 style={{ fontSize: 16 }}><i>Un estudio andaluz concluye que aquellos que tomaban algún fármaco para restituir esta vitamina en los días previos al ingreso hospitalario tenían mejor pronóstico</i></h5>
            <br />
            <p className="text-justify">Un trabajo llevado a cabo por el grupo de investigación liderado por Joaquín Dopazo, que está al frente del área de Bioinformática de la Fundación Progreso y Salud de la Junta de Andalucía, ha analizado la historia clínica de casi 16.000 pacientes y ha puesto de relieve que aquellos que tomaban algún fármaco para restituir la vitamina D durante los 15 días previos al ingreso hospitalario experimentaron una mayor tasa de supervivencia frente al Covid-19. </p>
            <p className="text-justify">Ahora ese estudio se encuentra entre las 100 publicaciones más descargadas de 2021, según la revista 'Scientific Reports', del grupo editorial Nature. En ese año se publicaron más de 24.500 artículos científicos. </p>
            <br />
            <p className="text-justify"> <a href="https://www.diariosur.es/sociedad/salud/papel-crucial-vitamina-d-supervivencia-frente-covid-20220411135009-nt.html"><i>leer más en su fuente original...</i></a></p>
          </div>

          <div className="col-md-6">
            <h4 style={{ fontSize: 18 }}><a target="_blank" rel="noreferrer" href="https://www.lavanguardia.com/vida/20211028/7823252/andalucia-lidera-secuenciacion-genomica-coronavirus-14-000-muestras.html">Andalucía lidera secuenciación genómica coronavirus, con casi 14.000 muestras</a></h4>
            <br />
            <a target="_blank" rel="noreferrer" href="https://www.lavanguardia.com/vida/20211028/7823252/andalucia-lidera-secuenciacion-genomica-coronavirus-14-000-muestras.html"> <img className="img-responsive" src="https://upload.wikimedia.org/wikipedia/commons/e/e4/La_Vanguardia_%28cabecera%29.svg" alt="vanguardia logo" /></a>
            <br /><br />

            <h5 style={{ fontSize: 16 }}><i>Sevilla, 28 oct (EFE).- Andalucía lidera a nivel nacional la secuenciación genómica del coronavirus con un total de 13.880 muestras de pacientes, lo que representa el 59,3 por ciento de lo que hay registrado en todo el país.</i></h5>
            <br />
            <p className="text-justify">Sevilla, 28 oct (EFE).- Andalucía lidera a nivel nacional la secuenciación genómica del coronavirus con un total de 13.880 muestras de pacientes, lo que representa el 59,3 por ciento de lo que hay registrado en todo el país.</p>
            <p className="text-justify">El análisis genómico de las muestras de pacientes que han padecido la covid-19 permite conocer mejor la enfermedad y su comportamiento con el fin de poder ofrecer alternativas terapéuticas eficaces, explica la Consejería de Salud en una nota de prensa.</p>
            <br />
            <p className="text-justify">Además, gracias a la secuenciación genómica, se puede realizar un estudio filogenético del virus, mostrando las mutaciones que experimenta a lo largo del tiempo, sus características y sus posibles relaciones con variantes de otros países o localidades, lo que facilita detectar las introducciones de virus y las cadenas de transmisión.</p>
            <p className="text-justify"> <a href="https://www.lavanguardia.com/vida/20211028/7823252/andalucia-lidera-secuenciacion-genomica-coronavirus-14-000-muestras.html"><i>leer más en su fuente original...</i></a></p>
          </div>

        </div>

        <br /><br /><br />
        <hr style={{ height: "5px" }} />
        <br /><br /><br /><br />

        <div className="row">
          <div className="col-md-6">
            <TranslatedText textKey="news-heading" />
            <br />
            <div className="embed-responsive embed-responsive-16by9 google-maps" id="youtubeVideo">
              <iframe
                className="embed-responsive-item"
                width="560"
                height="315"
                src="https://www.youtube.com/embed/YNYkYJo8xd0"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
            <br />
            <TranslatedText textKey="news-text" />
          </div>
        </div>
      </div>
    </div>
  );
}
